import React from "react";
import "./custom-error-component.scss";
interface ErrorProps {
  variant: "big" | "small";
  msg: string;
}

const CustomError: React.FC<ErrorProps> = ({ variant, msg }) => {
  const logoRetry = require("../../assets/error-retry.svg")?.default;
  const logoInfo = require("../../assets/info-icon.svg")?.default;
  const logoClose = require("../../assets/close-error-msg.svg")?.default;

  const closeMsg = () => {
    console.log("close");
  };
  // const defaultMsg =
  //   "Oops, something went wrong. We are resubmitting your request.";
  const msg2 =
    "Oops! Ask Tim is experiencing unusually high traffic helping others right now. Hang tight and try again in a moment. We appreciate your understanding!";
  const renderBigError = () => {
    return (
      <div className="bigMsg">
        <img src={logoInfo} alt="info" className="left-image"></img>
        <p>{msg || msg2}</p>
        <img
          src={logoClose}
          alt="close"
          className="right-image"
          onClick={closeMsg}
        ></img>
      </div>
    );
  };
  const renderSmallError = () => {
    return (
      <div className="smallMsg">
        <img src={logoRetry} alt="retry"></img>
        <p>{msg || "Retrying your answer"}</p>
      </div>
    );
  };
  const renderForm = () => {
    if (variant === "big") {
      return renderBigError();
    }
    return renderSmallError();
  };

  return renderForm();
};

export default CustomError;
